<template>
  <div>
    <KitchenConfidentialArticle/>
    <TheHundredYearsWarOnPalestineArticle/>
    <TheAgeOfDiagnosisArticle/>
    <OneDayEveryoneWillAlwaysHaveBeenAgainstThisArticle/>
    <BeyondTheWallArticle/>
    <IfThisIsAManTheTruceArticle/>
    <KillingThatcherArticle/>
  </div>
</template>

<script>
  import KillingThatcherArticle from '@/components/partials/articles/twentysix/KillingThatcherArticle.vue'
  import IfThisIsAManTheTruceArticle from '@/components/partials/articles/twentysix/IfThisIsAManTheTruceArticle.vue'
  import BeyondTheWallArticle from '@/components/partials/articles/twentysix/BeyondTheWallArticle.vue'
  import OneDayEveryoneWillAlwaysHaveBeenAgainstThisArticle from '@/components/partials/articles/twentysix/OneDayEveryoneWillAlwaysHaveBeenAgainstThisArticle.vue'
  import TheAgeOfDiagnosisArticle from '@/components/partials/articles/twentysix/TheAgeOfDiagnosisArticle.vue'
  import TheHundredYearsWarOnPalestineArticle from '@/components/partials/articles/twentysix/TheHundredYearsWarOnPalestineArticle.vue'
  import KitchenConfidentialArticle from '@/components/partials/articles/twentysix/KitchenConfidentialArticle.vue'



  export default {
  name: 'App',
  components: {
    KillingThatcherArticle,
    OneDayEveryoneWillAlwaysHaveBeenAgainstThisArticle,
    BeyondTheWallArticle,
    IfThisIsAManTheTruceArticle,
    TheAgeOfDiagnosisArticle,
    TheHundredYearsWarOnPalestineArticle,
    KitchenConfidentialArticle
  }
}
</script>